<template>
    <div class="form-row align-items-top">
        <div class="col-xs-6 col-md-4">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="no-of-adults">Adults (18+)</span>
                </div>
                <input id="no-of-adults" type="number" 
                    class="form-control" :class="{ invalid: $v.noOfAdults.$error }" placeholder="No. of Adults"
                    @blur="$v.noOfAdults.$touch()" 
                    :min="minAdults" :max="maxAdults" v-model.number="noOfAdults">
            </div>
            <div v-if="$v.noOfAdults.$error && !$v.noOfAdults.between" class="validation-message">
                We currently support booking between {{ $v.noOfAdults.$params.between.min }} and {{ $v.noOfAdults.$params.between.max }} adults.
            </div>
        </div>
        <div class="col-xs-6 col-md-4">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="no-of-children">Children (3-17)</span>
                </div>
                <input id="no-of-children" type="number" class="form-control" :class="{ invalid: $v.noOfChildren.$error }" 
                    placeholder="No. of Children"
                    @blur="$v.noOfChildren.$touch()" 
                    :min="minChildren" :max="maxChildren" v-model.number="noOfChildren" :disabled="noOfAdults == 0">
            </div>
            <div v-if="$v.noOfChildren.$error && !$v.noOfChildren.between" class="validation-message">
                We currently support booking between {{ $v.noOfChildren.$params.between.min }} and {{ $v.noOfChildren.$params.between.max }} children.
            </div>
        </div>
        <div class="col-xs-6 col-md-4">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="no-of-infants">Infants (0-2)</span>
                </div>
                <input id="no-of-infants" type="number" class="form-control" :class="{ invalid: $v.noOfInfants.$error }" 
                    placeholder="No. of Infants" 
                    @blur="$v.noOfInfants.$touch()" 
                    :min="minInfants" :max="maxInfants" v-model.number="noOfInfants" :disabled="noOfAdults == 0">
            </div>
            <div v-if="$v.noOfInfants.$error && !$v.noOfInfants.between" class="validation-message">
                We currently support booking between {{ $v.noOfInfants.$params.between.min }} and {{ $v.noOfInfants.$params.between.max }} infants.
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, between } from 'vuelidate/lib/validators'

export default {
    computed: {
        ...mapGetters({
            minAdults: 'getMinAdults',
            maxAdults: 'getMaxAdults',
            minChildren: 'getMinChildren',
            maxChildren: 'getMaxChildren',
            minInfants: 'getMinInfants',
            maxInfants: 'getMaxInfants',
        }),
        noOfAdults: { 
            get() { 
                return this.$store.state.passengers.noOfAdults;
            },
            set(value) { 
                this.$store.dispatch('setNoOfAdults', value);
            }
        },
        noOfChildren: { 
            get() { 
                return this.$store.state.passengers.noOfChildren;
            },
            set(value) { 
                this.$store.dispatch('setNoOfChildren', value);
            }
        },
        noOfInfants: { 
            get() { 
                return this.$store.state.passengers.noOfInfants;
            },
            set(value) { 
                this.$store.dispatch('setNoOfInfants', value);
            }
        },
    },
    validations() {
        return {
            noOfAdults: {
                required, 
                between(value) {
                    return between(this.minAdults, this.maxAdults)(value);
                },
            },
            noOfChildren: {
                between(value) {
                    return between(this.minChildren, this.maxChildren)(value);
                },
            },
            noOfInfants: {
               between(value) {
                    return between(this.minInfants, this.maxInfants)(value);
                },
            }
        }
    }
}
</script>